import { render, staticRenderFns } from "./schoolGradeManagement.vue?vue&type=template&id=1fc80b84&scoped=true&"
import script from "./schoolGradeManagement.vue?vue&type=script&lang=js&"
export * from "./schoolGradeManagement.vue?vue&type=script&lang=js&"
import style0 from "./schoolGradeManagement.vue?vue&type=style&index=0&id=1fc80b84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc80b84",
  null
  
)

export default component.exports